import { useState, useEffect, useRef, useCallback } from "react";
import api from "../../api";
import "../../CSS/DrsPreparation.css";
import { useRights } from "../RightsContext.jsx"; 


const DrsPre_PATH = "/DrsPreparation"; 

// ── HELPERS ────────────────────────────────────────────────────
const fmt  = (n) => (Math.round((n || 0) * 100) / 100).toFixed(2).replace(/\.00$/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const fmtK = (n) => n >= 100000 ? (n / 100000).toFixed(1) + "L" : n >= 1000 ? (n / 1000).toFixed(n >= 10000 ? 0 : 1) + "K" : String(n);
const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
const todayISO = () => new Date().toISOString().slice(0, 10);

// ── TOAST HOOK ─────────────────────────────────────────────────
function useToast() {
  const [toasts, setToasts] = useState([]);
  const toast = useCallback((msg, type = "info") => {
    const icons = { ok: "✓", err: "✕", warn: "⚠", info: "ℹ" };
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, msg, type, icon: icons[type] || "ℹ" }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 2800);
  }, []);
  return { toasts, toast };
}

// ── TOAST DISPLAY ──────────────────────────────────────────────
function ToastWrap({ toasts }) {
  return (
    <div className="drs-toast-wrap">
      {toasts.map((t) => (
        <div key={t.id} className={`drs-toast ${t.type}`}>
          <span style={{ fontSize: 15 }}>{t.icon}</span>
          {t.msg}
        </div>
      ))}
    </div>
  );
}

// ── SVG ICONS ──────────────────────────────────────────────────
const IconPlus    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14"/></svg>;
const IconBack    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>;
const IconSave    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v14a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>;
const IconPrint   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>;
const IconTrash   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/></svg>;
const IconEdit    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconFilter  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconDoc     = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IconScan    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 7V5a2 2 0 012-2h2M17 3h2a2 2 0 012 2v2M21 17v2a2 2 0 01-2 2h-2M7 21H5a2 2 0 01-2-2v-2"/><line x1="7" y1="12" x2="17" y2="12"/></svg>;
const IconGrid    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/></svg>;
const IconTruck   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 17H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v7a2 2 0 01-2 2h-2"/><circle cx="9" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>;
const IconInfo    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;

// ── MAIN COMPONENT ─────────────────────────────────────────────
export default function DrsPreparation() {
    const rights = useRights(DrsPre_PATH);
  // ── VIEW STATE ──
  const [view, setView] = useState("list"); // "list" | "builder"

  // ── MASTERS (from API) ──
  const [places, setPlaces] = useState([]);
  const [areas, setAreas] = useState([]);
  const [boys,  setBoys]  = useState([]);

  // ── LIST STATE ──
  const [drsList,    setDrsList]    = useState([]);
  const [fDest,      setFDest]      = useState("");
  const [fBoy,       setFBoy]       = useState("");
  // const [fFrom,      setFFrom]      = useState("");
  // const [fTo,        setFTo]        = useState("");
const [drsPage,     setDrsPage]     = useState(1);
const DRS_PAGE_SIZE = 10;

const [fFrom, setFFrom] = useState(todayISO());
const [fTo,   setFTo]   = useState(todayISO());
  // ── BUILDER STATE ──
  const [builderTitle,    setBuilderTitle]    = useState("DRS Preparation");
  const [curDrsNo,        setCurDrsNo]        = useState("");
  const [drsDate,         setDrsDate]         = useState(todayISO());
  const [drsPlace,        setDrsPlace]        = useState("");
  const [drsDest,         setDrsDest]         = useState("");
  const [drsBoy,          setDrsBoy]          = useState("");
  const [rows,            setRows]            = useState([]);
  const [editIndex,       setEditIndex]       = useState(-1);
  const [editingExisting, setEditingExisting] = useState(false);
  const [placeInvalid,    setPlaceInvalid]    = useState(false);
  const [destInvalid,     setDestInvalid]     = useState(false);
  const [boyInvalid,      setBoyInvalid]      = useState(false);
  // CNR currently blocked from being added because Is_Manifest != 'M'
  const [blockedCnr,      setBlockedCnr]      = useState(null);

  // Areas filtered by the selected Place — Area is dependent on Place
  const filteredAreas = drsPlace
    ? areas.filter((a) => String(a.placeId ?? "") === String(drsPlace))
    : areas;

  // ── ADD CONSIGNMENT INPUTS ──
  const [addCnr,  setAddCnr]  = useState("");
  const [addName, setAddName] = useState("");
  const [addAddr, setAddAddr] = useState("");
  const [addVal,  setAddVal]  = useState(0);
  const [addMobile, setAddMobile] = useState("");
  const [addPcs, setAddPcs] = useState(null);

  const cnrInputRef  = useRef(null);
  const nameInputRef = useRef(null);
  const valInputRef  = useRef(null);
  const printRef     = useRef(null);

  const { toasts, toast } = useToast();

  // ── INIT ──────────────────────────────────────────────────────
  useEffect(() => {
    loadMasters();
    loadDrsList();
  }, []);

  // TODO: confirm this matches the actual route of the shared Dropdown
  // controller/action shown above (e.g. it may be "/api/Common/dropdown"
  // or "/api/Master/dropdown" in your project) and adjust if needed.
  const DROPDOWN_URL = "/dropdown";

  const loadMasters = async () => {
    try {
      const [placesRes, areasRes, boysRes] = await Promise.all([
        api.get(DROPDOWN_URL, { params: { mode: "plc" } }),
        api.get("/api/drs/areas"),
        api.get("/api/drs/delivery-boys"),
      ]);
      // Dropdown API returns raw SQL column names: place_id, place_Name
      const placeRows = placesRes.data || [];
      setPlaces(placeRows.map((p) => ({
        id: p.place_id ?? p.Place_id ?? p.PlaceId,
        name: p.place_Name ?? p.Place_Name ?? p.PlaceName,
      })));
      setAreas(areasRes.data || []);
      setBoys(boysRes.data  || []);
    } catch {
      // masters failed — continue with empty lists
    }
  };

 const loadDrsList = async () => {
  try {
    const res = await api.get("/api/drs/list");

    console.log("DRS LIST API:", res.data);

    setDrsList(res.data || []);

  } catch (err) {

    console.log("DRS LIST ERROR:", err);

    setDrsList([]);
  }
};
  // ── STATS ─────────────────────────────────────────────────────
  const today    = todayISO();
  const todayDrs = drsList.filter((d) => d.date === today);
  const stats = {
    open:  drsList.filter((d) => d.status === "open").length,
    disp:  drsList.filter((d) => d.status === "dispatched").length,
    cnt:   todayDrs.reduce((a, d) => a + (d.rows?.length || 0), 0),
    val:   todayDrs.reduce((a, d) => a + (d.rows || []).reduce((s, r) => s + (r.val || 0), 0), 0),
  };

  // ── FILTERED LIST ─────────────────────────────────────────────
  const filteredList = drsList.filter((d) => {
    // if (fDest && d.area   !== fDest) return false;
    // if (fBoy  && d.boyId  !== fBoy)  return false;
    if(fDest && String(d.areaId)!==String(fDest))
     return false;

  if(fBoy && String(d.boyId)!==String(fBoy))
     return false;
    if (fFrom && d.date   <  fFrom)  return false;
    if (fTo   && d.date   >  fTo)    return false;
    return true;
  });

  const drsTotalPages = Math.max(1, Math.ceil(filteredList.length / DRS_PAGE_SIZE));
  const pagedList = filteredList.slice(
    (drsPage - 1) * DRS_PAGE_SIZE,
    drsPage * DRS_PAGE_SIZE
  );

  // Reset to page 1 whenever filters change the result set
  useEffect(() => {
    setDrsPage(1);
  }, [fDest, fBoy, fFrom, fTo, drsList.length]);

  // ── VIEW SWITCH ───────────────────────────────────────────────
  const showList = () => {
    setView("list");
    loadDrsList();
    window.scrollTo(0, 0);
  };

  // const newDRS = async () => {
  //   try {
  //     const res = await api.get("/api/drs/next-number");
  //     const no  = res.data?.drsNo || `DRS-${today.slice(2, 4)}${today.slice(5, 7)}-00001`;
  //     setCurDrsNo(no);
  //   } catch {
  //     setCurDrsNo(`DRS-${today.replace(/-/g, "").slice(2)}-00001`);
  //   }
  //   setBuilderTitle("DRS Preparation");
  //   setDrsDate(todayISO());
  //   setDrsDest("");
  //   setDrsBoy("");
  //   setRows([]);
  //   setEditIndex(-1);
  //   setEditingExisting(false);
  //   setDestInvalid(false);
  //   setBoyInvalid(false);
  //   clearEntry();
  //   setView("builder");
  //   window.scrollTo(0, 0);
  // };

  const newDRS = async () => {
  // Fetch DRS number from backend — generated from Configuration table
  let no = "";
  try {
    const res = await api.get("/api/drs/next-number");
    no = res.data?.drsNo || "";
    if (!no) {
      alert("Could not generate DRS number — check Configuration (DRS/DRNO settings)", "err");
      return;  // stop — don't open builder without a valid number
    }
  } catch (err) {
    alert(err.response?.data?.message || "Failed to generate DRS number", "err");
    return;    // stop — show the exact backend error
  }

  setCurDrsNo(no);
  setBuilderTitle("DRS Preparation");
  setDrsDate(todayISO());
  setDrsPlace("");
  setDrsDest("");
  setDrsBoy("");
  setRows([]);
  setEditIndex(-1);
  setEditingExisting(false);
  setPlaceInvalid(false);
  setDestInvalid(false);
  setBoyInvalid(false);
  clearEntry();
  setView("builder");
  window.scrollTo(0, 0);
};

  const openDRS = async (drs) => {
    setEditingExisting(true);
    const no = drs.drsNo || drs.no;
    try {
      // Fetch full detail rows from GET /api/drs/{drsNo}
      const res    = await api.get(`/api/drs/${no}`);
      const header = res.data.header || drs;
      const detailRows = res.data.rows || drs.rows || [];

      setCurDrsNo(no);
      setBuilderTitle(`Edit DRS · ${no}`);
      setDrsDate(header.date || drs.date);
      // Use numeric IDs for selects (AreaId / DeliveryBoyId)
      const areaId = String(header.areaId || drs.areaId || "");
      setDrsDest(areaId);
      // Prefer the Place stored on the DRS header itself; fall back to
      // deriving it from the Area's own place_id for older rows saved
      // before Place_Id existed on drs.DRSHeader.
      const headerPlaceId = header.placeId ?? drs.placeId;
      if (headerPlaceId != null) {
        setDrsPlace(String(headerPlaceId));
      } else {
        const areaObjForPlace = areas.find((a) => String(a.id) === areaId);
        setDrsPlace(areaObjForPlace?.placeId != null ? String(areaObjForPlace.placeId) : "");
      }
      setDrsBoy(String(header.boyId   || drs.boyId  || ""));
      setRows(detailRows.map((r) => ({ ...r })));
    } catch {
      // fallback to list data if detail fetch fails
      setCurDrsNo(no);
      setBuilderTitle(`Edit DRS · ${no}`);
      setDrsDate(drs.date);
      const areaId = String(drs.areaId || "");
      setDrsDest(areaId);
      if (drs.placeId != null) {
        setDrsPlace(String(drs.placeId));
      } else {
        const areaObjForPlace = areas.find((a) => String(a.id) === areaId);
        setDrsPlace(areaObjForPlace?.placeId != null ? String(areaObjForPlace.placeId) : "");
      }
      setDrsBoy(String(drs.boyId   || ""));
      setRows((drs.rows || []).map((r) => ({ ...r })));
    }
    setEditIndex(-1);
    setEditingExisting(true);
    setPlaceInvalid(false);
    setDestInvalid(false);
    setBoyInvalid(false);
    clearEntry();
    setView("builder");
    window.scrollTo(0, 0);
  };

  // ── MANDATORY VALIDATION ──────────────────────────────────────
  const checkMandatory = () => {
    const pi = !drsPlace;
    const di = !drsDest;
    const bi = !drsBoy;
    setPlaceInvalid(pi);
    setDestInvalid(di);
    setBoyInvalid(bi);
    return !pi && !di && !bi;
  };

  // ── FETCH CNR ─────────────────────────────────────────────────
  // const fetchCnr = async () => {
  //   let cnr = addCnr.trim().toUpperCase();
  //   if (!cnr) return;

  //   try {
  //     const res  = await api.get(`/api/drs/fetch-cnr?cnr=${encodeURIComponent(cnr)}`);
  //     const data = res.data;

  //     if (data?.success && data.booking) {
  //       const b = data.booking;
  //       setAddName(b.consignee_Name || b.consigneeName || "");
  //       setAddAddr(b.consignee_Address || b.consignee_Address || "");
  //       setAddVal(String(b.cons_Value || b.cons_Value || ""));
  //       setAddMobile(b.consignee_Mobile || b.consigneeMobile || "");
  //       setAddPcs(b.no_Pkgs || b.noPkgs || null);
  //       setBlockedCnr(null);
  //       setTimeout(() => valInputRef.current?.focus(), 50);
  //     } else if (data?.reason === "NOT_MANIFESTED") {
  //       // Only manifested consignments (Is_Manifest = 'M') may be added to a DRS.
  //       setBlockedCnr(cnr);
  //       alert(data.message || `${cnr} is not manifested and cannot be added to a DRS`, "err");
  //     } else {
  //       setBlockedCnr(null);
  //       alert("CNR not found — enter consignee details manually", "info");
  //       setTimeout(() => nameInputRef.current?.focus(), 50);
  //     }
  //   } catch {
  //     setBlockedCnr(null);
  //     alert("CNR not found — enter consignee details manually", "info");
  //     setTimeout(() => nameInputRef.current?.focus(), 50);
  //   }
  // };

  const fetchCnr = async () => {
  let cnr = addCnr.trim().toUpperCase();
  if (!cnr) return;

  try {
    // const params = { cnr };
    const params = { cnr, mode: "preparation" };
    if (editingExisting && curDrsNo) params.excludeDrsNo = curDrsNo;

    const res  = await api.get(`/api/drs/fetch-cnr`, { params });
    const data = res.data;

    if (data?.success && data.booking) {
      const b = data.booking;
      setAddName(b.consignee_Name || b.consigneeName || "");
      setAddAddr(b.consignee_Address || b.consignee_Address || "");
      setAddVal(String(b.cons_Value || b.cons_Value || ""));
      setAddMobile(b.consignee_Mobile || b.consigneeMobile || "");
      setAddPcs(b.no_Pkgs || b.noPkgs || null);
      setBlockedCnr(null);
      setTimeout(() => valInputRef.current?.focus(), 50);
    } else if (data?.reason === "OTP_NOT_REQUIRED") {
      // Otp_Required = 0 — this consignment is not eligible for DRS
      setBlockedCnr(cnr);
      alert(data.message || `${cnr} has Otp_Required = 0 and cannot be added to a DRS`, "err");
    } else if (data?.reason === "ALREADY_IN_DRS") {
      // Same CNR already used in a different DRS — block it
      setBlockedCnr(cnr);
      alert(data.message || `${cnr} is already added in DRS ${data.existingDrsNo}`, "err");
    } else if (data?.reason === "NOT_MANIFESTED") {
      setBlockedCnr(cnr);
      alert(data.message || `${cnr} is not manifested and cannot be added to a DRS`, "err");
    } else {
      setBlockedCnr(null);
      alert("CNR not found — enter consignee details manually", "info");
      setTimeout(() => nameInputRef.current?.focus(), 50);
    }
  } catch {
    setBlockedCnr(null);
    alert("CNR not found — enter consignee details manually", "info");
    setTimeout(() => nameInputRef.current?.focus(), 50);
  }
};
  // ── ADD / UPDATE ROW ─────────────────────────────────────────
  const addOrUpdate = () => {
    if (!checkMandatory()) { alert("Select Place, Delivery Area and Delivery Boy first", "warn"); return; }
    const cnr  = addCnr.trim().toUpperCase();
    const name = addName.trim();
    const addr = addAddr.trim();
    const val  = parseFloat(addVal) || 0;

    if (!cnr) { alert("Enter / scan a consignment number", "warn"); cnrInputRef.current?.focus(); return; }

    // Is_Manifest guard — matches the server-side check in /api/drs/fetch-cnr
    // and again in /api/drs/save. Only manifested consignments (Is_Manifest
    // = 'M') can be added to a DRS.
    // if (blockedCnr && blockedCnr === cnr) {
    //   alert(`${cnr} is not manifested and cannot be added to a DRS`, "err");
    //   return;
    // }
    if (blockedCnr && blockedCnr === cnr) {
      alert(`${cnr} cannot be added — it's either not manifested or already used in another DRS`, "err");
      return;
    }
    const dup = rows.findIndex((r) => r.cnr === cnr);
    if (dup !== -1 && dup !== editIndex) { alert(`${cnr} already in this DRS`, "warn"); return; }

    if (editIndex >= 0) {
      setRows((prev) => prev.map((r, i) => i === editIndex ? { cnr, name, addr, val, mobile: addMobile, pcs: addPcs } : r));
      // alert(`${cnr} updated`, "ok");
      setEditIndex(-1);
    } else {
      setRows((prev) => [...prev, { cnr, name, addr, val, mobile: addMobile, pcs: addPcs }]);
      alert(`${cnr} added`, "ok");
    }
    clearEntry();
    setTimeout(() => cnrInputRef.current?.focus(), 50);
  };

  const editRow = (i) => {
    const r = rows[i];
    setAddCnr(r.cnr);
    setAddName(r.name);
    setAddAddr(r.addr);
    setAddVal(String(r.val));
    setAddMobile(r.mobile || "");
    setAddPcs(r.pcs || null);
    setEditIndex(i);
    cnrInputRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const delRow = (i) => {
    setRows((prev) => prev.filter((_, idx) => idx !== i));
    if (editIndex === i) { setEditIndex(-1); clearEntry(); }
    alert("Consignment removed", "info");
  };

  const clearEntry = () => {
    setAddCnr("");
    setAddName("");
    setAddAddr("");
    setAddVal("");
    setAddMobile("");   // ← add
  setAddPcs(null); 
    setEditIndex(-1);
    setBlockedCnr(null);
  };

  // ── TOTALS ───────────────────────────────────────────────────
  const totVal = rows.reduce((a, r) => a + (r.val || 0), 0);
// Decode userId from JWT access token stored at login
const getUserId = () => {
  try {
    const token   = localStorage.getItem("token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.UserId || payload?.userId || null;
  } catch { return null; }
};

// Best-effort geolocation for Track_Master.Latitude/Longitude — resolves to
// { lat: null, lng: null } if unsupported, denied, or slow (2.5s timeout),
// so it never blocks saving the DRS.
const getGeoLocation = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) { resolve({ lat: null, lng: null }); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve({ lat: null, lng: null }),
      { timeout: 2500, maximumAge: 60000 }
    );
  });
  // ── SAVE ─────────────────────────────────────────────────────
  // const saveDRS = async (print = false) => {
  //   if (!checkMandatory()) { alert("Place, Delivery Area and Delivery Boy are mandatory", "err"); window.scrollTo(0, 0); return; }
  //   if (!rows.length)       { alert("Add at least one consignment", "warn"); return; }

  //   const boyObj  = boys.find((b) => String(b.id || b.boyId) === String(drsBoy));
  //   const areaObj = areas.find((a) => String(a.id) === String(drsDest));
  //   const { lat, lng } = await getGeoLocation();
  //   const rec = {
  //     drsNo:     curDrsNo,
  //     date:      drsDate,
  //     areaId:    parseInt(drsDest, 10),         // int FK → drs.DeliveryArea
  //     placeId:   drsPlace ? parseInt(drsPlace, 10) : null,   // int FK → drs.DRSHeader.Place_Id
  //     boyId:     parseInt(drsBoy,  10),         // int FK → drs.DeliveryBoy
  //     area:      areaObj?.name || drsDest,      // display only
  //     boy:       boyObj?.name  || boyObj?.boyName || drsBoy,
  //     latitude:  lat,   // → Track_Master.Latitude
  //     longitude: lng,   // → Track_Master.Longitude
  //     // createdBy is no longer sent from the client — the server resolves
  //     // it from the authenticated user's token (ResolveUserId()).
  //     // rows:      rows.map((r) => ({ cnr: r.cnr, name: r.name, addr: r.addr, val: parseFloat(r.val) || 0 })),
  //     rows: rows.map((r) => ({
  //     cnr: String(r.cnr).replace(/\s+/g, ""),
  //     name: r.name?.trim(),
  //     addr: r.addr?.trim(),
  //     val: parseFloat(r.val) || 0,
  //     mobile: r.mobile || null,   // ← add
  //     pcs:    r.pcs    || null
  //   }))
  //   };

  //   try {
  //     if (editingExisting){
  //       // await api.post(`/api/drs/${curDrsNo}`, rec);
  //       await api.post(`/api/drs/update/${curDrsNo}`, rec);
  //     }else{
  //       console.log("SAVE API CALL", rec);
  //       await api.post("/api/drs/save", rec);
  //     }
  //     // alert(`DRS ${curDrsNo} saved${print ? " — printing…" : ""}`, "ok");
  //     alert(`DRS Number: ${curDrsNo} ${editingExisting ? "updated" : "saved"}${print ? " — printing…" : ""}`, "ok");

  //     if (print) {
  //       await buildPrint(rec);
  //       // setTimeout(() => window.print(), 300);
  //     }

  //     setTimeout(showList, print ? 700 : 500);
  //   } catch (err) {
  //     alert(err.response?.data?.message || "Save failed", "err");
  //   }
  // };

  const saveDRS = async (print = false) => {
    if (!checkMandatory()) { alert("Place, Delivery Area and Delivery Boy are mandatory", "err"); window.scrollTo(0, 0); return; }
    if (!rows.length)       { alert("Add at least one consignment", "warn"); return; }

    const boyObj  = boys.find((b) => String(b.id || b.boyId) === String(drsBoy));
    const areaObj = areas.find((a) => String(a.id) === String(drsDest));
    const { lat, lng } = await getGeoLocation();
    const rec = {
      drsNo:     curDrsNo,
      date:      drsDate,
      areaId:    parseInt(drsDest, 10),         // int FK → drs.DeliveryArea
      placeId:   drsPlace ? parseInt(drsPlace, 10) : null,   // int FK → drs.DRSHeader.Place_Id
      boyId:     parseInt(drsBoy,  10),         // int FK → drs.DeliveryBoy
      area:      areaObj?.name || drsDest,      // display only
      boy:       boyObj?.name  || boyObj?.boyName || drsBoy,
      latitude:  lat,   // → Track_Master.Latitude
      longitude: lng,   // → Track_Master.Longitude
      // createdBy is no longer sent from the client — the server resolves
      // it from the authenticated user's token (ResolveUserId()).
      rows: rows.map((r) => ({
        cnr: String(r.cnr).replace(/\s+/g, ""),
        name: r.name?.trim(),
        addr: r.addr?.trim(),
        val: parseFloat(r.val) || 0,
        mobile: r.mobile || null,   // ← add
        pcs:    r.pcs    || null
      }))
    };

    try {
      let saveRes;
      if (editingExisting) {
        // await api.post(`/api/drs/${curDrsNo}`, rec);
        saveRes = await api.post(`/api/drs/update/${curDrsNo}`, rec);
      } else {
        console.log("SAVE API CALL", rec);
        saveRes = await api.post("/api/drs/save", rec);
      }
      // alert(`DRS ${curDrsNo} saved${print ? " — printing…" : ""}`, "ok");
      alert(`DRS Number: ${curDrsNo} ${editingExisting ? "updated" : "saved"}${print ? " — printing…" : ""}`, "ok");

      // Preparation OTPs are auto-sent server-side for consignments
      // flagged Otp_Required = 1 — just surface the count here.
      const otpCount = saveRes?.data?.otpSentCount || 0;
      if (otpCount > 0) {
        //show otp no temp
        // alert(`OTP sent to ${otpCount} consignee${otpCount !== 1 ? "s" : ""}`, "info");
        const debug = saveRes.data.otpDebug || [];

        // TEMP: on-screen OTP display for testing — remove once
        // SMS/WhatsApp templates are approved.
        const otpLines = debug
          .map((d) => `${d.consignmentNo}: ${d.otp}`)
          .join("\n");

        alert(
          `OTP sent to ${otpCount} consignee${otpCount !== 1 ? "s" : ""}\n${otpLines}`,
          "info"
        );

        debug.forEach((d) => {
          console.log(`OTP for ${d.consignmentNo}: ${d.otp}`);

        // TEMP: remove once SMS/WhatsApp templates are approved
        // (saveRes.data.otpDebug || []).forEach(d => {
        //   console.log(`OTP for ${d.ConsignmentNo}: ${d.Otp}`);
        });
      }

      if (print) {
        await buildPrint(rec);
        // setTimeout(() => window.print(), 300);
      }

      setTimeout(showList, print ? 700 : 500);
    } catch (err) {
      alert(err.response?.data?.message || "Save failed", "err");
    }
  };
  
  const cancelDRS = () => {
    if (rows.length && !window.confirm("Discard this DRS? Unsaved changes will be lost.")) return;
    showList();
  };

  const deleteDRS = async () => {
    if (!window.confirm(`Delete DRS ${curDrsNo}? This cannot be undone.`)) return;
    try {
      // await api.post(`/api/drs/${curDrsNo}`);
      await api.post(`/api/drs/delete/${curDrsNo}`);
      alert(`DRS ${curDrsNo} deleted`, "info");
      showList();
    } catch {
      alert("Delete failed", "err");
    }
  };

//   const printDRS = () => {

//   const boyObj = boys.find(
//     (b) => String(b.id || b.boyId) === String(drsBoy)
//   );

//   const areaObj = areas.find(
//     (a) => String(a.id) === String(drsDest)
//   );


//   const rec = {
//     drsNo: curDrsNo,
//     date: drsDate,

//     area: areaObj?.name || drsDest,

//     boy:
//       boyObj?.name ||
//       boyObj?.boyName ||
//       drsBoy,

//     rows: rows.map((r)=>({
//       cnr: r.cnr,
//       name: r.name,
//       addr: r.addr,
//       val: parseFloat(r.val) || 0
//     }))
//   };


//   if(!rec.rows.length){
//     alert("No consignments to print","warn");
//     return;
//   }


//   buildPrint(rec);


//   setTimeout(()=>{
//     window.print();
//   },300);

// };
  // ── PRINT ────────────────────────────────────────────────────

      const buildPrint = async (rec) => {
  const tv = (rec.rows || []).reduce((a, r) => a + (r.val || 0), 0);

  let companyName    = "";
  let companyAddress = "";
  try {
    const res   = await api.get("/api/manifest/company-detail");
    companyName    = res.data.company?.company_Name    || res.data.company?.Company_Name    || "";
    companyAddress = res.data.company?.company_Address || res.data.company?.Company_Address || "";
  } catch { /* proceed without company info */ }

  const rowsHtml = (rec.rows || []).map((r, i) => `
    <tr>
      <td style="text-align:center">${i + 1}</td>
      <td style="font-weight:700">${r.cnr}</td>
      <td>${r.name || "—"}</td>
      <td>${r.addr || "—"}</td>
      <td style="text-align:right">₹ ${fmt(r.val)}</td>
      <td style="border-bottom:1px solid #ddd;min-width:90px;"></td>
    </tr>`).join("");

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>DRS — ${rec.drsNo}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, sans-serif; font-size: 11px; color: #111; }
    .company-header { background: #1e2d40; color: #fff; text-align: center; padding: 10px 16px; }
    .company-header .co-name { font-size: 16px; font-weight: 700; letter-spacing: .5px; text-transform: uppercase; }
    .company-header .co-addr { font-size: 9px; color: #bcc8d8; margin-top: 3px; }
    .report-heading { text-align: center; padding: 6px 12px; font-size: 13px; font-weight: 700; letter-spacing: .4px; text-transform: uppercase; border: 1px solid #ccc; border-top: none; background: #f5f7fa; color: #1e2d40; }
    .info-section { border: 1px solid #ccc; border-top: none; padding: 8px 12px; }
    .info-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px 12px; }
    .info-cell { display: flex; flex-direction: column; }
    .info-cell .lbl { font-size: 8px; font-weight: 700; color: #666; text-transform: uppercase; letter-spacing: .4px; }
    .info-cell .val { font-size: 11px; font-weight: 600; color: #111; margin-top: 1px; }
    .tbl-section { margin-top: 8px; }
    table { width: 100%; border-collapse: collapse; }
    thead tr { background: #1e2d40; color: #fff; }
    thead th { padding: 5px 6px; font-size: 9px; font-weight: 700; text-align: left; text-transform: uppercase; letter-spacing: .3px; border: 1px solid #3a4f66; }
    tbody tr:nth-child(even) { background: #f5f7fa; }
    tbody td { padding: 4px 6px; border: 1px solid #ddd; font-size: 10px; vertical-align: middle; }
    tfoot td { padding: 5px 6px; font-weight: 700; font-size: 10px; background: #e8edf3; border: 1px solid #ccc; }
    .print-bar { display: flex; justify-content: flex-end; padding: 8px 12px; background: #f0f2f5; border-bottom: 1px solid #ddd; }
    .print-bar button { background: #1e2d40; color: #fff; border: none; padding: 6px 18px; font-size: 13px; font-weight: 600; border-radius: 4px; cursor: pointer; letter-spacing: .3px; }
    .print-bar button:hover { background: #2e4460; }
    .sign-row { margin-top: 30px; display: flex; justify-content: space-between; font-size: 12px; color: #334155; padding: 0 4px; }
    @media print {
      .print-bar { display: none; }
      @page { margin: 10mm; }
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <div class="print-bar"><button onclick="window.print()">🖨️ Print</button></div>
  <div class="company-header">
    <div class="co-name">${companyName}</div>
    <div class="co-addr">${companyAddress}</div>
  </div>
  <div class="report-heading">Delivery Run Sheet (DRS) Report</div>
  <div class="info-section">
    <div class="info-grid">
      <div class="info-cell"><span class="lbl">DRS Number</span><span class="val">${rec.drsNo || "—"}</span></div>
      <div class="info-cell"><span class="lbl">DRS Date</span><span class="val">${fmtDate(rec.date)}</span></div>
      <div class="info-cell"><span class="lbl">Status</span><span class="val">${rec.status ? rec.status.toUpperCase() : "OPEN"}</span></div>
      <div class="info-cell"><span class="lbl">Delivery Area</span><span class="val">${rec.area || "—"}</span></div>
      <div class="info-cell"><span class="lbl">Delivery Boy</span><span class="val">${rec.boy || "—"}</span></div>
      <div class="info-cell"><span class="lbl">Total Consignments</span><span class="val">${(rec.rows || []).length}</span></div>
    </div>
  </div>
  <div class="tbl-section">
    <table>
      <thead>
        <tr>
          <th style="text-align:center">#</th>
          <th>Consignment No</th>
          <th>Consignee Name</th>
          <th>Consignee Address</th>
          <th style="text-align:right">Value (₹)</th>
          <th style="text-align:center">Signature</th>
        </tr>
      </thead>
      <tbody>${rowsHtml}</tbody>
      <tfoot>
        <tr>
          <td colspan="4">TOTAL</td>
          <td style="text-align:right">₹ ${fmt(tv)}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="sign-row">
    <div>Delivery Boy Sign: ____________________</div>
    <div>Supervisor Sign: ____________________</div>
  </div>
</body>
</html>`;

  const blob = new Blob([html], { type: "text/html" });
  const url  = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

  // ─────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────
  return (
    <div className="drs-root">
      <div className="drs-page">

        {/* ══ LIST VIEW ══════════════════════════════════════ */}
        {view === "list" && (
          <div className="list-view">

            {/* Header */}
            <div className="pg-row">
              <div className="pg-title">
                <h1>Delivery Run Sheet (DRS)</h1>
                <p>Prepare delivery run sheets — assign consignments to a delivery boy by area</p>
              </div>
              <div className="pg-acts">
                {rights.add && (
                  <button className="drs-btn drs-btn-primary drs-btn-lg" onClick={newDRS}>
                    <IconPlus /> New DRS
                  </button>
                )}
              </div>
            </div>

            {/* Stats */}
            <div className="drs-stat-row">
              <div className="stat-box amber"><div className="sb-val">{stats.open}</div><div className="sb-lbl">Open DRS</div></div>
              <div className="stat-box blue"> <div className="sb-val">{stats.disp}</div><div className="sb-lbl">Dispatched</div></div>
              <div className="stat-box teal"> <div className="sb-val">{stats.cnt}</div> <div className="sb-lbl">Consignments Today</div></div>
              <div className="stat-box navy"> <div className="sb-val">₹{fmtK(stats.val)}</div><div className="sb-lbl">Total Value Today</div></div>
            </div>

            {/* Filters */}
            <div className="drs-card">
              <div className="drs-band navy-band">
                <div className="drs-band-icon"><IconFilter /></div>
                <div><div className="drs-band-title">Filters</div></div>
              </div>
              <div className="drs-card-body">
                <div className="drs-filter-grid">
                  <div className="drs-field">
                    <label>Destination / Area</label>
                    <select value={fDest} onChange={(e) => setFDest(e.target.value)}>
                      <option value="">All Areas</option>
                      {areas.map((a) => <option key={a.id || a} value={a.id || a}>{a.name || a}</option>)}
                    </select>
                  </div>
                  <div className="drs-field">
                    <label>Delivery Boy</label>
                    <select value={fBoy} onChange={(e) => setFBoy(e.target.value)}>
                      <option value="">All Delivery Boys</option>
                      {boys.map((b) => <option key={b.id || b.boyId} value={b.id || b.boyId}>{b.name || b.boyName}</option>)}
                    </select>
                  </div>
                  <div className="drs-field">
                    <label>From Date</label>
                    <input type="date" value={fFrom} onChange={(e) => setFFrom(e.target.value)} />
                  </div>
                  <div className="drs-field">
                    <label>To Date</label>
                    <input type="date" value={fTo} onChange={(e) => setFTo(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>

            {/* DRS Register Table */}
            <div className="drs-card">
              <div className="drs-band teal-band">
                <div className="drs-band-icon"><IconTruck /></div>
                <div>
                  <div className="drs-band-title">DRS Register</div>
                  <div className="drs-band-sub">Click a DRS to open or edit</div>
                </div>
                <div className="drs-band-r">
                  <span className="drs-band-badge">{filteredList.length} DRS</span>
                </div>
              </div>
              <div className="tbl-scroll">
                <table className="drs-list-table">
                  <thead>
                    <tr>
                      <th>DRS No.</th><th>Date</th><th>Destination / Area</th>
                      <th>Delivery Boy</th><th className="c">Consignments</th>
                      <th className="r">Total Value</th><th className="c">Status</th><th className="c">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredList.length === 0 ? (
                      <tr><td colSpan="8" style={{ textAlign: "center", padding: 34, color: "var(--muted)" }}>No DRS found</td></tr>
                    // ) : filteredList.map((d) => {
                      ) : pagedList.map((d) => {
                      const val = (d.rows || []).reduce((s, r) => s + (r.val || 0), 0);
                      const pillCls = { open: "pill-open", dispatched: "pill-dispatched", closed: "pill-closed" }[d.status] || "pill-open";
                      const pillLbl = { open: "⏳ Open", dispatched: "🚚 Dispatched", closed: "✓ Closed" }[d.status] || d.status;
                      return (
                        <tr key={d.drsNo || d.no} onClick={() => openDRS(d)}>
                          <td><span className="drs-no-link">{d.drsNo || d.no}</span></td>
                          <td style={{ color: "var(--slate)" }}>{fmtDate(d.date)}</td>
                          <td style={{ fontWeight: 700, color: "var(--teal)" }}>📍 {d.area}</td>
                          <td style={{ fontWeight: 600 }}>🛵 {d.boy}</td>
                          <td className="c"><strong style={{ color: "var(--blue)" }}>{d.totalConsignments}</strong></td>
                          <td className="r" style={{ fontWeight: 700, color: "var(--navy)" }}>₹ {fmt(val)}</td>
                          <td className="c"><span className={`pill ${pillCls}`}>{pillLbl}</span></td>
                          <td className="c">
                            {rights.edit && (
                              <button
                                className="drs-btn drs-btn-ghost drs-btn-sm"
                                onClick={(e) => { e.stopPropagation(); openDRS(d); }}
                              >
                                Open
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
               {filteredList.length > 0 && (
                <div className="drs-pager">
                  <button
                    className="drs-btn drs-btn-ghost drs-btn-sm"
                    disabled={drsPage === 1}
                    onClick={() => setDrsPage((p) => Math.max(1, p - 1))}
                  >
                    ‹ Prev
                  </button>
                  <span className="drs-pager-info">
                    Page {drsPage} of {drsTotalPages}
                  </span>
                  <button
                    className="drs-btn drs-btn-ghost drs-btn-sm"
                    disabled={drsPage === drsTotalPages}
                    onClick={() => setDrsPage((p) => Math.min(drsTotalPages, p + 1))}
                  >
                    Next ›
                  </button>
                </div>
              )}
            </div>

          </div>
        )}

        {/* ══ BUILDER VIEW ═══════════════════════════════════ */}
        {view === "builder" && (
          <div className="builder-view">

            {/* Header */}
            <div className="pg-row">
              <div className="pg-title">
                <h1>{builderTitle}</h1>
                <p>Assign consignments to a delivery boy for a delivery area</p>
              </div>
              <div className="pg-acts">
                <button className="drs-btn drs-btn-ghost drs-btn-sm" onClick={cancelDRS}>
                  <IconBack /> Back
                </button>
              </div>
            </div>

            {/* Mandatory note */}
            <div className="req-note">
              <IconInfo />
              <span><b>Place</b>, <b>Delivery Area</b> and <b>Delivery Boy</b> are mandatory. Select Place first — Area options depend on it — then Delivery Boy, before adding consignments.</span>
            </div>

            {/* DRS Details */}
            <div className="drs-card">
              <div className="drs-band navy-band">
                <div className="drs-band-icon"><IconDoc /></div>
                <div>
                  <div className="drs-band-title">DRS Details</div>
                  <div className="drs-band-sub">Run sheet header</div>
                </div>
              </div>
              <div className="drs-card-body">
                <div className="drs-g4">
                  <div className={`drs-field mandatory${placeInvalid ? " invalid" : ""}`}>
                    <label>Place <span className="req">*</span></label>
                    <select
                      value={drsPlace}
                      onChange={(e) => {
                        setDrsPlace(e.target.value);
                        if (e.target.value) setPlaceInvalid(false);
                        // Area depends on Place — clear any Area no longer valid for the new Place
                        setDrsDest("");
                      }}
                    >
                      <option value="">— Select Place —</option>
                      {places.map((p) => (<option key={p.id} value={p.id}>{p.name}</option>))}
                    </select>
                    <span className="field-err">Place is required</span>
                  </div>

                  <div className={`drs-field mandatory${destInvalid ? " invalid" : ""}`}>
                    <label>Delivery Area / Destination <span className="req">*</span></label>
                    <select
                      value={drsDest}
                      disabled={!drsPlace}
                      onChange={(e) => { setDrsDest(e.target.value); if (e.target.value) setDestInvalid(false); }}
                    >
                      <option value="">{drsPlace ? "— Select Area —" : "— Select Place first —"}</option>
                      {filteredAreas.map((a) => (<option key={a.id} value={a.id}> {a.name} </option>))}
                    </select>
                    <span className="field-err">Delivery area is required</span>
                  </div>

                  <div className={`drs-field mandatory${boyInvalid ? " invalid" : ""}`}>
                    <label>Delivery Boy <span className="req">*</span></label>
                    <select
                      value={drsBoy}
                      onChange={(e) => { setDrsBoy(e.target.value); if (e.target.value) setBoyInvalid(false); }}
                    >
                      <option value="">— Select Delivery Boy —</option>
                      {boys.map((b) => <option key={b.id || b.boyId} value={b.id || b.boyId}>{b.name || b.boyName}</option>)}
                    </select>
                    <span className="field-err">Delivery boy is required</span>
                  </div>

                  <div className="drs-field">
                    <label>DRS No.</label>
                    <input type="text" className="ro" value={curDrsNo} readOnly />
                  </div>

                  <div className="drs-field">
                    <label>DRS Date</label>
                    <input type="date" value={drsDate} onChange={(e) => setDrsDate(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>

            {/* Add Consignment */}
            <div className="drs-card add-card">
              <div className="drs-band teal-band">
                <div className="drs-band-icon"><IconScan /></div>
                <div>
                  <div className="drs-band-title">Add Consignment</div>
                  <div className="drs-band-sub">Scan / enter CNR — details fetch automatically</div>
                </div>
              </div>
              <div className="drs-card-body">
                <div className="add-grid">
                  <div className="drs-field">
                    <label>
                      Cons No <span className="req">*</span>&nbsp;
                      <span className="scan-tag">SCAN</span>
                    </label>
                    <input
                      ref={cnrInputRef}
                      type="text"
                      placeholder="Scan / enter CNR"
                      autoComplete="off"
                      style={{ textTransform: "uppercase", fontWeight: 700, letterSpacing: ".5px" }}
                      value={addCnr}
                      onChange={(e) => setAddCnr(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); fetchCnr(); } }}
                    />
                  </div>

                  <div className="drs-field">
                    <label>Consignee Name</label>
                    <input
                      ref={nameInputRef}
                      type="text"
                      placeholder="Auto / enter"
                      value={addName}
                      onChange={(e) => setAddName(e.target.value)}
                    />
                  </div>

                  <div className="drs-field">
                    <label>Consignee Address</label>
                    <input
                      type="text"
                      placeholder="Auto / enter"
                      value={addAddr}
                      onChange={(e) => setAddAddr(e.target.value)}
                    />
                  </div>

                  <div className="drs-field">
                    <label>Cons Value (₹)</label>
                    <input
                      ref={valInputRef}
                      type="number"
                      min="0"
                      step="1"
                      placeholder="0"
                      value={addVal}
                      onChange={(e) => setAddVal(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addOrUpdate(); } }}
                    />
                  </div>

                  <div className="add-btns">
                    {rights.add && (
                      <button
                        className={`drs-btn ${editIndex >= 0 ? "drs-btn-amber" : "drs-btn-teal"}`}
                        onClick={addOrUpdate}
                      >
                        <IconPlus />
                        {/* {editIndex >= 0 ? "Update" : "Add"} */}
                      Add
                    </button>)}
                    <button className="drs-btn drs-btn-ghost" onClick={clearEntry}>Clear</button>
                  </div>
                </div>
              </div>
            </div>

            {/* Consignment Grid */}
            <div className="drs-card">
              <div className="drs-band navy-band">
                <div className="drs-band-icon"><IconGrid /></div>
                <div>
                  <div className="drs-band-title">Consignments in this DRS</div>
                  <div className="drs-band-sub">Delivery list</div>
                </div>
                <div className="drs-band-r">
                  <span className="drs-band-badge">{rows.length} CNR</span>
                </div>
              </div>
              <div className="tbl-scroll">
                <table className="drs-grid">
                  <thead>
                    <tr>
                      <th className="c">No</th>
                      <th>Consignment No</th>
                      <th>Consignee Name</th>
                      <th>Consignee Address</th>
                      <th className="r">Cons. Value</th>
                      <th className="c">Edit</th>
                      <th className="c">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0 ? (
                      <tr>
                        <td colSpan="7">
                          <div className="grid-empty">
                            <div className="grid-empty-ico">🚚</div>
                            <div className="grid-empty-title">No consignments added</div>
                            <div className="grid-empty-sub">Scan or enter a CNR above to build the run sheet</div>
                          </div>
                        </td>
                      </tr>
                    ) : rows.map((r, i) => (
                      <tr key={i} className={i === editIndex ? "editing" : ""}>
                        <td className="c"><span className="dg-sn">{i + 1}</span></td>
                        <td><span className="dg-cnr">{r.cnr}</span></td>
                        <td><span className="dg-name">{r.name || "—"}</span></td>
                        <td><span className="dg-addr">{r.addr || "—"}</span></td>
                        <td className="r"><span className="dg-val">₹ {fmt(r.val)}</span></td>
                        <td className="c">
                         {rights.edit && (
                            <button className="ic-btn ic-edit" onClick={() => editRow(i)} aria-label="Edit">
                              <IconEdit />
                            </button>
                          )}
                        </td>
                        <td className="c">
                          {rights.delete && (
                            <button className="ic-btn ic-del" onClick={() => delRow(i)} aria-label="Delete">
                            <IconTrash />
                          </button>)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {rows.length > 0 && (
                    <tfoot>
                      <tr>
                        <td colSpan="4" className="lbl">
                          Total · {rows.length} consignment{rows.length !== 1 ? "s" : ""}
                        </td>
                        <td className="r">₹ {fmt(totVal)}</td>
                        <td colSpan="2"></td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>

            {/* Action Bar */}
            <div className="drs-action-bar">
              <div className="drs-action-bar-inner">
                <div className="ab-summary">
                  <div className="ab-sum-item">
                    <div className="ab-sum-val">{rows.length}</div>
                    <div className="ab-sum-lbl">Consignments</div>
                  </div>
                  <div className="ab-sum-item">
                    <div className="ab-sum-val">₹{fmtK(totVal)}</div>
                    <div className="ab-sum-lbl">Total Value</div>
                  </div>
                </div>
                <div className="ab-actions">
                  <button className="drs-btn drs-btn-ghost" onClick={cancelDRS}>Cancel</button>
                  {editingExisting && (
                    <button className="drs-btn drs-btn-red" onClick={deleteDRS}>Delete</button>
                  )}
                 {rights.add && (
                    <button className="drs-btn drs-btn-navy" onClick={() => saveDRS(false)}>
                      <IconSave /> {editingExisting ? "Update" : "Save"}
                    </button>
                  )}
                  {/* <button className="drs-btn drs-btn-green" onClick={() => saveDRS(true)}> */}
                  {/* <button className="drs-btn drs-btn-green"  onClick={printDRS}>
                    <IconPrint /> Print
                  </button> */}
                   {rights.export && (
                  <button className="drs-btn drs-btn-green" onClick={async () => {
                  const boyObj  = boys.find((b) => String(b.id || b.boyId) === String(drsBoy));
                  const areaObj = areas.find((a) => String(a.id) === String(drsDest));
                  const rec = {
                    drsNo:  curDrsNo,
                    date:   drsDate,
                    status: "OPEN",
                    area:   areaObj?.name || drsDest,
                    boy:    boyObj?.name  || boyObj?.boyName || drsBoy,
                    rows:   rows.map((r) => ({ cnr: r.cnr, name: r.name, addr: r.addr, val: parseFloat(r.val) || 0 })),
                  };
                  if (!rec.rows.length) { alert("No consignments to print", "warn"); return; }
                  await buildPrint(rec);
                }}>
                  <IconPrint /> Print
                </button>)}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>{/* /drs-page */}

      {/* Print area */}
      <div className="drs-print-area" ref={printRef} />

      {/* Toasts */}
      <ToastWrap toasts={toasts} />

    </div>
  );
}